import { Injectable } from '@angular/core';
import { ControllerService } from './shared/services/controller.service';
import swal from 'sweetalert2';


@Injectable()
export class ReferencesService {

  constructor(private controller: ControllerService) { }


   showReferences(video) {

      let content = ''

      const reference = this.controller.getReferencePageForVideoId(video)

      if( !reference ){
        content = '<h1>No references found</h1>'
      }else{
        const elements = reference.elements.map( (it) => {
          if( it.type == 'header'){
            if( it.value == 'References' ){
              return '<h1>' + it.value + '</h1>'
            }
            return '<h2>' + it.value + '</h2>'
          }
          if( it.type == 'p'){
            return '<p>' + it.value + '</p>'
          }
          if( it.type == 'link'){
            return "<p><a target=\"_blank\" href='" + it.value + "'>" + it.value + "</a></p>"
          }
        })
        content = elements.join('')
      }

      swal({
      title: '',
      customClass: 'references-alert',
      html: content,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false
      });
      return false
    }
}
